<template>
  <div
    :class="`tw-flex tw-flex-col tw-w-full ${
      isOpen ? 'opened' : ''
    } mainWrapper`"
    @click.stop
  >
    <!-- Dropdown button -->
    <div
      @click="
        () => {
          if (isLoading) return;
          isOpen = !isOpen;
          if (!isOpen) {
            handleSearch('');
          }
        }
      "
    >
      <slot name="buttonDropdown">
        <div
          v-if="isLoading"
          :class="`tw-w-full tw-flex tw-rounded-[6px] tw-bg-[#ffffff] tw-pl-[6px] ${
            showLandingText ? 'tw-z-[4]' : ''
          }`"
        >
          <div class="tw-h-[38px] tw-w-[38px] tw-justify-end">
            <!-- eslint-disable vue/no-unused-refs -->
            <LottieAnimation
              ref="anim"
              :animation-data="ProgressAnimation"
              :auto-play="true"
              :loop="true"
            />
          </div>
        </div>
        <div
          v-if="!isLoading"
          :class="`${
            showLandingText ? 'tw-z-[4]' : ''
          } tw-relative tw-min-h-[47px] tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-self-stretch tw-px-[20px] tw-py-[10px] tw-w-full tw-rounded-t-[6px] ${
            isOpen
              ? 'tw-bg-[#F6F7F8] header-shadow'
              : 'tw-bg-[#FFF] tw-rounded-b-[6px]'
          } dropdownButton`"
        >
          <div
            class="tw-max-w-full tw-overflow-x-auto tw-overflow-y-hidden placeholder"
          >
            <div
              v-if="showLandingText"
              class="tw-flex tw-justify-center tw-items-center tw-gap-[8px] tw-cursor-pointer"
            >
              <span
                :class="`tw-flex-1 tw-font-Poppins tw-text-[#231F20] tw-text-[11px] tw-not-italic tw-font-[400] tw-leading-[130%] title tw-line-clamp-2`"
                >{{
                  getComponentUiText(
                    "app-component-assessment-switcher-landing-text-1",
                  )
                }}
              </span>
            </div>
            <div
              v-else-if="
                getChecklistSelected(
                  data,
                  currentChecklistReportId,
                  isTopLevelOnly,
                )
              "
              class="tw-flex tw-justify-center tw-items-center tw-gap-[8px] tw-cursor-pointer"
            >
              <span
                :class="`tw-flex-1 tw-font-Poppins tw-text-[#231F20] tw-text-[11px] tw-not-italic tw-font-[400] tw-leading-[130%] title tw-line-clamp-2`"
                ><span
                  class="tw-font-[500]"
                  data-cy="assessment-switcher-dropdown"
                  >{{
                    getChecklistSelected(
                      data,
                      currentChecklistReportId,
                      isTopLevelOnly,
                    )?.checklistName
                  }}</span
                >{{
                  ` - ${convertUTCTimeToLocalTime(
                    getChecklistSelected(
                      data,
                      currentChecklistReportId,
                      isTopLevelOnly,
                    )?.checklistDate,
                  )}`
                }}</span
              >
              <AssessmentChecklistStatusTag
                :checklist-status="
                  getChecklistSelected(
                    data,
                    currentChecklistReportId,
                    isTopLevelOnly,
                  )?.checklistStatus
                "
                :checklist-status-id="
                  getChecklistSelected(
                    data,
                    currentChecklistReportId,
                    isTopLevelOnly,
                  )?.checklistStatusId
                "
                :is-loading="false"
                class-name="tw-leading-[130%] tw-h-[24px] tw-px-[8px]"
              />
            </div>
          </div>
          <span
            :class="`tw-z-[1] arrowIcon ${
              isOpen ? 'rotated tw-pr-[10px]' : 'tw-pl-[10px]'
            }`"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10"
              height="7"
              viewBox="0 0 10 7"
              fill="none"
            >
              <path
                d="M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z"
                fill="#387DFF"
              />
            </svg>
          </span>
        </div>
      </slot>
    </div>
    <!-- Dropdown body -->
    <div
      :class="`dropdownBody tw-flex tw-flex-col tw-rounded-bl-[6px] tw-rounded-br-[6px] tw-bg-white tw-max-h-[260px] !tw-overflow-y-auto ${dropdownClass}`"
    >
      <div
        id="search"
        :class="` tw-flex tw-items-center tw-gap-[13px] tw-self-stretch tw-px-[26px] tw-h-[42px] tw-py-[12px]`"
      >
        <div class="tw-flex tw-flex-row tw-items-center">
          <SearchIcon
            color="#B7B7B7"
            :class="`tw-w-[12px] tw-h-[12px] icon-pointer-unset`"
          />
        </div>
        <input
          ref="inputRef"
          :value="modelValue"
          type="text"
          class="tw-border-none tw-w-full searchInput tw-h-[18px]"
          :placeholder="
            getComponentUiText(
              'app-recommentdation-assessment-switcher-search-placeholder-1',
            )
          "
          @input="(e: any) => handleSearch(e?.target?.value)"
        />
        <button
          v-if="modelValue !== ''"
          type="button"
          class="tw-bg-transparent tw-border-none tw-outline-none"
          @click="clearData"
        >
          <CloseBoxIcon :size="15" color="#DBDBDB" />
        </button>
      </div>
      <AssessmentSwitcherDropdownItem
        v-for="(item, index) of dataShown"
        :key="index"
        :is-top-level-only="isTopLevelOnly"
        :index="index"
        :item="item"
        :level="0"
        :is-modal-open="isOpen"
        :search-value="searchValue"
        @update:selected="
          (checklist) => {
            if (showLandingText) {
              showLandingText = false;
              store.dispatch('Overlay/hideOverlay');
            }

            isOpen = false;
            if (!isOpen) {
              handleSearch('');
            }
            emits('on-select-checklist', checklist, index);
          }
        "
        @update:child-selected="
          (itemChildData) => {
            isOpen = false;
            if (!isOpen) {
              handleSearch('');
            }
            emits('on-select-checklist', itemChildData, index);
          }
        "
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ProgressAnimation from "../../../assets/animation/progress_light.json";
import { LottieAnimation } from "lottie-web-vue";
import {
  computed,
  onBeforeMount,
  onBeforeUnmount,
  ref,
  watch,
  Ref,
  onMounted,
} from "vue";
import AssessmentSwitcherDropdownItem from "./assessmentSwitcherDropdownItem.vue";
import {
  getChecklistSelected,
  getComponentUiText,
  resultFilter,
} from "@/utils/utilities";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import store from "@/store";
import CloseBoxIcon from "@/components/svgs/closeBoxIcon.vue";
import AssessmentChecklistStatusTag from "@/components/assessment/assessmentChecklistStatusTag.vue";
import SearchIcon from "@/components/svgs/searchIcon.vue";

const emits = defineEmits(["on-select-checklist"]);

const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
  dropdownClass: {
    type: String,
    required: false,
    default: "",
  },
  isTopLevelOnly: {
    type: Boolean,
    required: false,
    default: false,
  },
  isLoading: {
    type: Boolean,
    required: false,
    default: false,
  },
  isNoData: {
    type: Boolean,
    required: false,
    default: false,
  },
  isShowLandingPage: {
    type: Boolean,
    required: false,
    default: false,
  },
});
const showLandingText = ref(false);
const modelValue: Ref<string> = ref("");
const inputRef = ref<HTMLInputElement | null>(null);
const isOpen = ref(false);
const dataShown: any = ref(props.data);
const searchValue = ref("");

watch(
  () => props.data,
  () => {
    dataShown.value = props.data;
  },
);
watch(
  () => props.isNoData,
  () => {
    if (props.isNoData && props.isShowLandingPage) {
      showLandingText.value = false;
    }
  },
);
watch(
  () => props.isLoading,
  () => {
    if (props.isLoading && props.isShowLandingPage) {
      showLandingText.value = true;
      store.dispatch("Overlay/showOverlay", {
        isShowOverlay: true,
      });
    }
  },
);
onMounted(() => {
  if (props.isShowLandingPage) {
    store.dispatch("Overlay/showOverlay", {
      isShowOverlay: true,
    });
    showLandingText.value = true;
  }
});
const clearData = () => {
  handleSearch("");
  inputRef.value?.focus();
};
const handleSearch = (value: string) => {
  modelValue.value = value;
  searchValue.value = value;
  dataShown.value = resultFilter(value, props.data, props.isTopLevelOnly);
};

const currentChecklistReportId = computed(
  () =>
    store.getters["Recommend/getChecklistReportId"] ||
    store.getters["Sharing/getChecklistReportId"],
);

onBeforeMount(() => {
  window.addEventListener("click", () => {
    handleSearch("");
    isOpen.value = false;
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {
    isOpen.value = false;
  });
});
</script>

<style scoped>
.mainWrapper {
  position: relative;
}
.rotated {
  transform: rotate(180deg);
}

.dropdownBody {
  height: 0;
  overflow: hidden;
  /* transition: height 0.3s ease-in-out; */
  position: absolute;
  width: 100%;
  top: 46px;
  z-index: 1060;
  box-shadow: 0px 8px 13px rgba(0, 0, 0, 0.2);
}
.opened .dropdownBody {
  height: auto;
  border: 1px solid #eff0f1;
  border-top: 0px;
}

.header-shadow {
  box-shadow: rgba(0, 0, 0, 0.2) 0 1px 13px 2px;
}

.dropdownBody > *:not(:last-child) {
  border-bottom: 1px solid #eff0f1;
}

.searchInput {
  color: #000000;
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.searchInput::placeholder {
  color: #b7b7b7;
}

.blurred {
  width: 63px;
  height: 56px;
  background: linear-gradient(
    270deg,
    #f6f7f8 62.64%,
    rgba(246, 247, 248, 0) 98.36%
  );
}

.placeholder {
  cursor: w-resize;
  background-color: transparent !important;
  opacity: 1;
}

.placeholder::-webkit-scrollbar {
  display: none;
}

.dropdownButton {
  border: 1px solid #eff0f1;
}

.is-invalid-input {
  .blurred {
    background: #fee5e2 !important;
  }
  .dropdownButton {
    background: #fee5e2 !important;
  }
}
</style>
